import React from 'react';
import ProdurctSearchResult from './ProdurctSearchResult';
import { getdivClassStatic as availabilityClassName } from '../../Basepage/parts/Availability';

import img_packet from '../../Basepage/parts/images/button-paket-outline.svg';
import img_portofrei from '../../Basepage/parts/images/button-portofrei-outline.svg';

import img_LeserPrube from '../../Basepage/parts/images/button-leseprobe-outline.svg';

//import './../ProductsDetails/Availability.css';
import { replaceAllComplex } from '../../../../../mol_function';
import MolLink from '../../Basepage/parts/Menu/MolLink';
import { showMediumInSearchPage, useMolLinkInSearchResult } from '../overrides';
import { CSSProperties } from 'react';

interface ResultItemProp {
  item: ProdurctSearchResult;
  domainPrefix: string;
}

export default class ResultItem extends React.Component<ResultItemProp> {
  render() {
    let showSolarResult = false;

    let inlineStyle: CSSProperties = {};

    if (
      this.props.item.scoreInfo != undefined &&
      this.props.item.scoreInfo.scoreParts != undefined
    ) {
      showSolarResult = true;

      let scoreDet = 0;
      if (this.props.item.scoreInfo.hasKeywordSearch) scoreDet = 40;

      let height =
        450 + this.props.item.scoreInfo.scoreParts.length * 35 + scoreDet + 50;
      inlineStyle.height = height + 'px';
    }

    let avc = availabilityClassName(
      this.props.item.products_delivery_time_status,
    );

    let vKategorie = this.props.item.pov_Kategorie_VALUE;
    let vMedium = this.props.item.Medium;

    if (vKategorie == 'Buch' && vMedium == 'MP3-CD') {
      vKategorie = 'Hörbuch';
    } else if (vKategorie == 'Buch' && vMedium == 'CD') {
      vKategorie = 'Hörbuch';
    } else if (vKategorie == 'Buch' && vMedium == 'Kalender') {
      vKategorie = 'Kalender';
      vMedium = '';
    } else if (vKategorie == 'Buch' && vMedium == 'Brettspiel') {
      vKategorie = 'Spielware';
    } else if (vKategorie == 'Musik' && vMedium == 'T-Shirt') {
      vKategorie = 'Merchandising';
    } else if (vKategorie == 'Musik' && vMedium == 'Merchandising') {
      vKategorie = 'Merchandising';
      vMedium = '';
    } else if (vKategorie == 'Spielware' && vMedium == 'Kalender') {
      vKategorie = 'Kalender';
      vMedium = '';
    } else if (vKategorie == 'Fim' && vMedium == 'T-Shirt') {
      vKategorie = 'Merchandising';
    } else if (vKategorie == 'Schreibwaren' && vMedium == 'Kalender') {
      vKategorie = 'Kalender';
      vMedium = '';
    } else if (vKategorie == 'Schreibwaren' && vMedium == 'Brettspiel') {
      vKategorie = 'Spielware';
    } else if (vKategorie == 'Kalender' && vMedium == 'Kalender') {
      vKategorie = 'Kalender';
      vMedium = '';
    }

    let tagTitle = vKategorie;
    if (vMedium != undefined && vMedium != '') tagTitle += ' - ' + vMedium;
    tagTitle += ' - ' + this.props.item.pov_TITEL_VALUE;

    let reactLink = '/product_info/' + this.props.item.products_id;

    return (
      <div className="productBox" style={inlineStyle}>
        <div className="image_container">
          <div className="label_container">
            <div className="productInfos">
              {this.props.item.isNewProduct ? (
                <img
                  className="productFlag"
                  src={
                    this.props.domainPrefix + '/images/layout/button-neu.svg'
                  }
                />
              ) : null}
              {this.props.item.isShipingFree ? (
                <img
                  className="productFlag"
                  src={img_portofrei}
                  title="dieses Produkt liefern wir Ihnen portofrei"
                />
              ) : null}
              {this.props.item.isPackageSend ? (
                <img
                  className="productFlag"
                  src={img_packet}
                  title="dieses Produkt versenden wir ohne Zusatzkosten als Paket"
                />
              ) : null}
              {this.props.item.hasMedia || this.props.item.mediaCount > 0 ? (
                <img className="productFlag" src={img_LeserPrube} />
              ) : null}

              <div id="Availability">
                <div className={avc}>&nbsp;</div>
              </div>
            </div>
          </div>
          {useMolLinkInSearchResult() && reactLink != '' ? (
            <MolLink
              to={reactLink}
              href={this.props.item.linkShort}
              inlinePadding={false}
            >
              <div style={{ width: '100%', height: '100%' }}>
                <img
                  className="productImage"
                  src={
                    'https://media.moluna.de/images/' +
                    this.props.item.products_image
                  }
                />
              </div>
            </MolLink>
          ) : (
            <a href={this.props.item.linkShort} title={tagTitle}>
              <div style={{ width: '100%', height: '100%' }}>
                <img
                  className="productImage"
                  src={
                    'https://media.moluna.de/images/' +
                    this.props.item.products_image
                  }
                />
              </div>
            </a>
          )}
        </div>

        <div className="productDesc">
          <a href={this.props.item.link} title={tagTitle}>
            <div className="product_title">
              <div className="medium">
                {vKategorie}
                {showMediumInSearchPage() &&
                vMedium != undefined &&
                vMedium != '' ? (
                  <React.Fragment>
                    {' - '}
                    {vMedium}
                  </React.Fragment>
                ) : null}
              </div>

              {replaceAllComplex(this.props.item.pov_TITEL_VALUE, [
                { s: "\\'", r: "'" },
                { s: '\\"', r: '"' },
              ])}
            </div>

            {this.props.item.scoreInfo != undefined ? (
              <div className="solrDebug">
                score: {this.props.item.scoreInfo.totalScore}
                <br />
                {this.props.item.scoreInfo.hasKeywordSearch ? (
                  <div>
                    keyword: {this.props.item.scoreInfo.keywordScore}
                    <br />
                    keywordSum: {this.props.item.scoreInfo.keywordSum}
                    {' * '}
                    {this.props.item.scoreInfo.keywordMulti}
                    <br />
                    boost: {this.props.item.scoreInfo.boostScore}
                    <br />
                    boostSum: {this.props.item.scoreInfo.boostSum}
                    {' * '}
                    {this.props.item.scoreInfo.boostMulti}
                  </div>
                ) : null}
                {this.props.item.scoreInfo.scoreParts.map((sp, indexsp) => {
                  let text = sp.score + ' => ' + sp.index + ':' + sp.keyword;

                  let text2 =
                    sp.keywordFreq +
                    'x in ' +
                    sp.keywordFreqDocs +
                    ' von ' +
                    sp.keywordFreqAllDocs;
                  let className = 'solrDebugParts';

                  if (sp.keywordPart) {
                    className += ' keyword';
                  }

                  return (
                    <div
                      className={className}
                      id={'SolrSearchDet' + indexsp}
                      key={'SolrSearchDet' + indexsp}
                    >
                      <div>{text}</div>
                      <div>{text2}</div>
                    </div>
                  );
                })}
              </div>
            ) : null}

            <div className="price">{this.props.item.productPrice}</div>
          </a>
        </div>
      </div>
    );
  }
}
